import { MatterTeamSchema } from "@/lib/data/schemas/matters/MatterSchema";
import { z } from "zod";

export const MAX_MATTER_TEAM_LABEL_LENGTH = 50;

const localMatterTeammateSchema = z.object({
  matterTeammateId: z.string(),
  id: z.string(),
  matterRoleId: z.string(),
});

export const matterTeamFormSchema = MatterTeamSchema.pick({
  label: true,
  description: true,
}).extend({
  label: z
    .string()
    .trim()
    .min(1, "Label is required")
    .max(
      MAX_MATTER_TEAM_LABEL_LENGTH,
      `Label must be ${MAX_MATTER_TEAM_LABEL_LENGTH} characters or fewer`,
    ),
  newMatterTeammates: z.array(localMatterTeammateSchema).default([]),
  deletedMatterTeammateIds: z.array(z.string()).default([]),
});

export type MatterTeamFormValues = z.infer<typeof matterTeamFormSchema>;

export const defaultMatterTeamFormValues: MatterTeamFormValues = {
  label: "",
  description: "",
  newMatterTeammates: [],
  deletedMatterTeammateIds: [],
};
